export default __webpack_public_path__ + "cf592a06a814be5d1c477dbc41b3a3ce.svg";